import { Component } from '@angular/core';
import { MegamenuComponent } from '../../megamenu/megamenu.component';
import { FooterComponent } from '../../footer/footer.component';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { CommonModule } from '@angular/common';
import { CompanyConfigService, CompanyConfig } from '../../../services/company-config.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-general-pest-control',
  templateUrl: './general-pest-control.component.html',
  styleUrl: './general-pest-control.component.css',
  imports: [MegamenuComponent, FooterComponent, MatButtonModule, MatIconModule, MatCardModule, CommonModule]
})
export class GeneralPestControlComponent {
  config: CompanyConfig;

  pests = [
    { name: 'Ants', icon: 'bug_report', description: 'Complete ant colony elimination and prevention' },
    { name: 'Spiders', icon: 'pest_control', description: 'Safe spider removal and web elimination' },
    { name: 'Cockroaches', icon: 'bug_report', description: 'Thorough cockroach extermination' },
    { name: 'Silverfish', icon: 'pest_control', description: 'Silverfish control and moisture management' },
    { name: 'Earwigs', icon: 'bug_report', description: 'Earwig elimination and entry point sealing' },
    { name: 'Beetles', icon: 'pest_control', description: 'Protection against various beetle species' }
  ];

  features = [
    { title: 'Year-round Protection', description: 'Scheduled treatments designed to keep pests away in every season', icon: 'schedule' },
    { title: 'Interior & Exterior', description: 'Comprehensive protection both inside and outside your property', icon: 'home' },
    { title: 'Safe for Family & Pets', description: 'EPA-approved products that are safe around children and animals', icon: 'pets' },
    { title: 'Guaranteed Results', description: 'We stand behind our work with a satisfaction guarantee', icon: 'verified' }
  ];

  constructor(
    private companyConfig: CompanyConfigService,
    private router: Router
  ) {
    this.config = this.companyConfig.getConfig();
  }

  callPhone() {
    this.companyConfig.callPhone();
  }

  navigateToContact() {
    this.router.navigate(['/contact']);
  }
}